import {
  addDoc,
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/config";

const isProduction =
  process.env.REACT_APP_FIREBASE_ENV === "production" ||
  (process.env.REACT_APP_FIREBASE_ENV !== "development" &&
    process.env.NODE_ENV === "production");

// Dedicated collection — never dinoHighScores / mazeHighScores.
export const OPS_TICKLES_SCORES_COLLECTION = isProduction
  ? "production_opsTicklesPointsHighScores"
  : "opsTicklesPointsHighScores";

const GAME_ID = "opsTickles";

export const saveOpsTicklesPointsScore = async ({
  userId,
  displayName,
  points,
}) => {
  if (!db || !userId || !displayName) {
    return null;
  }

  const pointsValue = Math.max(0, Math.floor(Number(points) || 0));
  const payload = {
    gameId: GAME_ID,
    userId,
    displayName,
    points: pointsValue,
    score: pointsValue,
    timestamp: new Date(),
  };

  const docRef = await addDoc(
    collection(db, OPS_TICKLES_SCORES_COLLECTION),
    payload
  );

  return { id: docRef.id, ...payload };
};

export const fetchOpsTicklesPointsScores = async (limitCount = 10) => {
  if (!db) return [];

  try {
    const q = query(
      collection(db, OPS_TICKLES_SCORES_COLLECTION),
      orderBy("points", "desc"),
      limit(limitCount)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs
      .map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }))
      .filter((row) => {
        if (row.gameId !== GAME_ID) return false;
        const points = Number(row.points ?? row.score ?? 0);
        return Number.isFinite(points) && points >= 0 && points <= 500;
      })
      .slice(0, limitCount);
  } catch (error) {
    // Missing collection / index → blank. Do not fall back to any other game.
    console.warn(
      `[Ops-tickles] Blank board (${OPS_TICKLES_SCORES_COLLECTION}):`,
      error?.message || error
    );
    return [];
  }
};

export const syncOpsTicklesDisplayName = async (userId, newDisplayName) => {
  if (!db || !userId) return;
  try {
    const userScoresQuery = query(
      collection(db, OPS_TICKLES_SCORES_COLLECTION),
      where("userId", "==", userId)
    );
    const snapshot = await getDocs(userScoresQuery);
    if (snapshot.empty) return;

    await Promise.all(
      snapshot.docs.map((docSnap) =>
        setDoc(
          doc(db, OPS_TICKLES_SCORES_COLLECTION, docSnap.id),
          { displayName: newDisplayName },
          { merge: true }
        )
      )
    );
  } catch (error) {
    console.error("Error syncing Ops-tickles display names:", error);
  }
};
